<template>
    <div id="viewer">
        <iframe src = "/repository/fsnto2008.tbl.pdf" width='90%' height='90%' allowfullscreen webkitallowfullscreen></iframe>
    </div>
</template>


<script>
export default {
    name: "viewer"
    
}
</script>
